import * as React from "react";
const cloneElement: any = React.cloneElement;

interface IProps {
    error: boolean;
    isLoading: boolean;
    isReady: boolean;
}

export class Export extends React.Component<IProps, any> {
    static Selection = ({ children, error, isLoading, isReady }: any) =>
        !error && !isLoading && !isReady ? children : null;
    static Loading = ({ children, error, isLoading }: any) => (!error && isLoading ? children : null);
    static Ready = ({ children, error, isReady }: any) => (!error && isReady ? children : null);
    static Error = ({ children, error }: any) => (error ? children : null);

    render() {
        const { error, isLoading, isReady } = this.props;

        return React.Children.map(this.props.children, (childElement) => {
            return cloneElement(childElement, {
                error,
                isLoading,
                isReady,
            });
        });
    }
}
